<script>
import { mapState, mapActions } from 'vuex';
import { LOAD_PROTOTYPES } from '@/store/types/action-types';

import ItemBrowser from './_item-browser';

export default {
    name: 'prototype-browser',

    extends: ItemBrowser,

    data() {
        return {
            itemType: 'prototype',
            defaultItemImg: 'https://via.placeholder.com/150x225?text=template',
        };
    },

    computed: {
        ...mapState({
            prototypes: ({ page }) => page.prototypes,
        }),
    },

    methods: {
        ...mapActions({
            loadPrototypes: LOAD_PROTOTYPES,
        }),

        async loadItems() {
            await this.loadPrototypes();
            this.items = this.prototypes;
        },
    },
};
</script>
